/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tag } from './Tag';
import {
    TagFromJSON,
    TagFromJSONTyped,
    TagToJSON,
    TagToJSONTyped,
} from './Tag';

/**
 * 
 * @export
 * @interface UpdateTagResponse
 */
export interface UpdateTagResponse {
    /**
     * 
     * @type {Tag}
     * @memberof UpdateTagResponse
     */
    data: Tag;
}

/**
 * Check if a given object implements the UpdateTagResponse interface.
 */
export function instanceOfUpdateTagResponse(value: object): value is UpdateTagResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateTagResponseFromJSON(json: any): UpdateTagResponse {
    return UpdateTagResponseFromJSONTyped(json, false);
}

export function UpdateTagResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTagResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TagFromJSON(json['data']),
    };
}

  export function UpdateTagResponseToJSON(json: any): UpdateTagResponse {
      return UpdateTagResponseToJSONTyped(json, false);
  }

  export function UpdateTagResponseToJSONTyped(value?: UpdateTagResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TagToJSON(value['data']),
    };
}

